import * as d3 from 'd3'

export default {

  methods: {

    draw_Donuts() {

      let cir = this.circle
      let title = this.title

      let chart = this.canvasForms
      .append('g')
      .attr('transform', `translate(5, 5)`)

      let cx = cir.front.radius
      this.columns.forEach((col,i)=> {
        
        let values = chart
        .append('g')
        .attr('transform', `translate(${cx}, ${cir.front.radius})`)

        // Main Value
        if(this.value.main.visible == 'Y') {
          let main = values
          .append('g')
          .attr('id', `MAIN_GROUP_${this.localId}_${i}`)
          .attr('transform', `translate(0, 1)`)
          .call(this.event_Link, col, i) // event_Link

          main
          .append('text')
          .attr('id', `MAIN_${this.localId}_${i}`).attr('y', this.value.sub.visible == 'Y' ? 0 : 5)
          .attr('fill', this.value.main.tColor).attr('font-size', this.value.main.tSize)
          .text(this.rawData[i][this.value.main.code])

          main
          .append('text')
          .attr('x', this.getNode(`#MAIN_${this.localId}_${i}`)).attr('y', this.value.sub.visible == 'Y' ? 0 : 5)
          .attr('fill', this.value.main.tColor).attr('font-size', this.value.main.tSize-3)
          .text(this.value.main.unit)

          d3.select(`#MAIN_GROUP_${this.localId}_${i}`)
          .attr('transform', `translate(${-(this.getNode(`#MAIN_GROUP_${this.localId}_${i}`)/2)}, 1)`)
        }

        // Sub Value
        if(this.value.sub.visible == 'Y') {
          values
          .append('text')
          .attr('x', 0).attr('y', 5 + this.value.sub.tSize*0.75)
          .attr('fill', this.value.sub.tColor).attr('font-size', this.value.sub.tSize)
          .attr('text-anchor', 'middle')
          .text(this.rawData[i][this.value.sub.code] + this.value.sub.unit)
          .call(this.event_Link, col, i) // event_Link
        }
        // Title
        values
        .append('text')
        .attr('x', 0).attr('y', cir.front.radius + title.padding + title.tSize*0.75)
        .attr('fill', title.tColor).attr('font-size', title.tSize)
        .attr('text-anchor', 'middle')
        .text(col.name)

        this.draw_Circle(chart, cx, col, this.rawData[i].PROG) // -----> Below
        cx = cx + (cir.space + (cir.front.radius*2))
      })

    },



    draw_Circle(selection, cx, col, prog) {

      let cir = this.circle
      let endAn = ''

      cir.back.radius = cir.front.radius - ((cir.front.thick - cir.back.thick)/2)

      let arc1 = d3.arc()
      .outerRadius(cir.back.radius)
      .innerRadius(cir.back.radius - cir.back.thick)
      .startAngle(Math.PI / 180)
      .endAngle(() => endAn || 360 * Math.PI / 180)

      let arc2 = d3.arc()
      .outerRadius(cir.front.radius)
      .innerRadius(cir.front.radius - cir.front.thick)
      .startAngle(Math.PI / 180)
      .endAngle(() => endAn || 360 * Math.PI / 180)
      .cornerRadius(cir.front.thick)

      let chart = selection
      .append('g')
      .attr('transform', `translate(${cx}, ${cir.front.radius})`)

      chart
      .append('path')
      .attr('d', arc1).attr('fill', cir.back.color).attr('opacity', cir.back.opacity)

      chart
      .append('path')
      .attr('d', arc2)
      .attr('fill', col.fColor).attr('opacity', cir.front.opacity)
      .transition().duration(500)
      .attrTween('d', ()=> {
        let endAngle_ = ( ((360 * (prog/100)) ) * Math.PI / 180)
        let interpolate = d3.interpolate(0 * Math.PI / 180, endAngle_)
        return function(t) {
          endAn = interpolate(t)
          return arc2()
        }
      })
    },

  } 
}